import { Box } from '@wix/design-system';
import React from 'react';
import { ActionSummary } from './ActionSummary';
import { StatusSummary } from './StatusSummary';
export const Summary = _ref => {
  let {
    onLinkClick
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP3"
  }, /*#__PURE__*/React.createElement(ActionSummary, {
    onLinkClick: onLinkClick
  }), /*#__PURE__*/React.createElement(StatusSummary, null));
};
//# sourceMappingURL=Summary.js.map